import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import IBC4EUApp from './IBC4EU/App';
import PasswordGate from './IBC4EU/PasswordGate';
import reportWebVitals from './reportWebVitals';

const isIBC4EU = window.location.pathname.toLowerCase().startsWith('/ibc4eu');

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  isIBC4EU ? (
    <PasswordGate>
      <IBC4EUApp />
    </PasswordGate>
  ) : (
    <App />
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
